// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-legend-label.em-spike-legend-label {
    font-size:12px;
}`, "",{"version":3,"sources":["webpack://./src/css/legend/spike.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB","sourcesContent":[".em-legend-label.em-spike-legend-label {\r\n    font-size:12px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
